'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
/*tslint:disable */
var Validation = function Validation(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 20 2 11' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { id: 'Fill-2', d: 'M1 27c-.6 0-1-.4-1-1v-5c0-.6.4-1 1-1s1 .4 1 1v5c0 .6-.4 1-1 1zm0 2c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z', className: 'st0' })
    )
  );
};
/*tslint:enable */
/*eslint-enable */

exports.default = Validation;